import { Package } from "lucide-react";
import { buildCdnURL } from "../../../utils/utils";

const getRandomPastelColor = (id) => {
  const colors = [
    "bg-blue-100 dark:bg-blue-900",
    "bg-green-100 dark:bg-green-900",
    "bg-yellow-100 dark:bg-yellow-900",
    "bg-red-100 dark:bg-red-900",
    "bg-purple-100 dark:bg-purple-900",
    "bg-pink-100 dark:bg-pink-900",
    "bg-indigo-100 dark:bg-indigo-900",
    "bg-teal-100 dark:bg-teal-900",
  ];

  const lastChar = id.slice(-1);
  const index = Number.parseInt(lastChar, 16) % colors.length;
  return colors[index];
};

export default function CategoryTab({ category, isSelected, onClick }) {
  return (
    <div
      className={`bg-white dark:bg-gray-800 rounded-xl shadow-sm border cursor-pointer min-w-[180px] flex-shrink-0 ${
        isSelected
          ? "border-blue-700 ring-2 ring-blue-200 dark:ring-blue-800"
          : "border-gray-100 dark:border-gray-700"
      } p-2 transition-all duration-200`}
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0">
          {category.images?.[0] ? (
            <img
              src={
                buildCdnURL(category.images[0]) || "/assets/placeholder.webp"
              }
              alt={category.name}
              className="w-full h-full object-cover"
            />
          ) : (
            <div
              className={`w-full h-full flex items-center justify-center ${getRandomPastelColor(
                category._id
              )}`}
            >
              <Package className="w-6 h-6 text-gray-600 dark:text-gray-400" />
            </div>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-medium text-gray-800 dark:text-gray-200 capitalize text-sm leading-tight truncate">
            {category.name}
          </h3>
        </div>
      </div>
    </div>
  );
}
